import { AngularSvgIconModule } from "angular-svg-icon";
import { NgClickOutsideDirective } from "ng-click-outside2";
import { ClipboardModule } from "ngx-clipboard";

import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
// Dialog components
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { MatTooltipModule } from "@angular/material/tooltip";
import { RouterModule } from "@angular/router";

import { NavigationComponent } from "../../components/common/navigation/navigation";
import { ConfirmationDialogService } from "../../services/confirmation-dialog";
import { LoadingState } from "../../services/loading-state";
import { PolicyService } from "../../services/policyservice";
import { namedApolloProvider } from "../graphql.module";

@NgModule({
  declarations: [],
  imports: [
    AngularSvgIconModule,
    ClipboardModule,
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatTableModule,
    MatTooltipModule,
    NavigationComponent,
    NgClickOutsideDirective,
    RouterModule,
  ],
  providers: [ConfirmationDialogService, PolicyService, LoadingState, namedApolloProvider],
  exports: [
    AngularSvgIconModule,
    ClipboardModule,
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatTableModule,
    MatTooltipModule,
    NgClickOutsideDirective,
    RouterModule,
  ],
})
export class NwdSharedModule {}
